import { customContextFactory } from '../../../../../../hooks';
import { useScheduleReadOnlyRequestDetails } from '../hooks';

type ContextType = ReturnType<typeof useScheduleReadOnlyRequestDetails>;

export const [ScheduleReadOnlyRequestDetailsContextProvider, useScheduleReadOnlyRequestDetailsContext] =
  customContextFactory<ContextType>();
